import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

const TrustpilotContainerFullWidth = styled.div`
  background-color: #f8f8f8;
  padding: 40px 32px;
  min-height: 296px;
`

const TrustpilotContainer = styled.div`
  max-width: 916px;
  margin: 0 auto;
  text-align: center;

  h1 {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    color: #00b67a;
    margin: 0;
  }

  h2 {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    color: #000;
    margin: 0;
  }
`

const TrustpilotWidget = styled.div`
  margin-top: 32px;
`

export const Trustpilot = () => {
  const ref = useRef(null)

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <TrustpilotContainerFullWidth>
      <TrustpilotContainer>
        <h1>4,9 / 5 sur plus de 3700 avis</h1>
        <h2>La référence en termes de qualité sur le marché</h2>
        <TrustpilotWidget
          ref={ref}
          className="trustpilot-widget"
          data-locale="fr-FR"
          data-template-id="53aa8912dec7e10d38f59f36"
          data-businessunit-id="4ec0e70b00006400051186d3"
          data-style-height="140px"
          data-style-width="100%"
          data-theme="light"
          data-stars="5"
          data-review-languages="fr"
        >
          <a href="Nextories (ex i-Demenager) est noté « Excellent » avec 4,9 / 5 sur Trustpilot " target="_blank" rel="noopener">
            Trustpilot
          </a>
        </TrustpilotWidget>
      </TrustpilotContainer>
    </TrustpilotContainerFullWidth>
  )
}
